import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";
import { GetDashboardSharingTokenResData } from "./GetDashboardSharingTokenResData";

const ENDPOINT = "/dashboard/";

export class GetDashboardSharingTokenCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor(dashboardId: number) {
        super();
        this.endPoint += dashboardId + "/sharingToken";
    }

    public async execute(): Promise<GetDashboardSharingTokenResData> {
        var res = await this.executeCommand();
        return new GetDashboardSharingTokenResData(res);
    }
}
